import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SLOAN_SEARCH_QUOTES_FEATURE, SloanQuotesState } from './sloan-quotes.state';

export const getQuoteListState = createFeatureSelector<SloanQuotesState>(SLOAN_SEARCH_QUOTES_FEATURE);

export const getQuotes = createSelector(getQuoteListState, (state: SloanQuotesState) => state.quote);

export const getQuotesSpinner = createSelector(getQuoteListState, (state: SloanQuotesState) => state.showSpinner);
